import React, { useState, useEffect } from "react";
import styles from "./findHouseGirl.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faMapMarkerAlt, faStar,  } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { Link } from 'react-router-dom'

const baseURL = `${process.env.REACT_APP_API_URL}`

const FindHouseGirl = () => {
  const [filters, setFilters] = useState({
    location: "",
    rating: "",
    experience: "",
  });

  const [profiles, setProfiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchHouseManagers = async () => {
      setIsLoading(true)
      try {
        const response = await axios.get(`${baseURL}/profiles/housemanagers/`);
        setProfiles(response.data)
      } catch(error) {
        console.log('Error in fetching house managers', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchHouseManagers();
  }, [])

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSearch = async () => {
    setIsLoading(true)
    try {
      const params = new URLSearchParams(filters).toString();
      const response = await axios.get(`${baseURL}/profiles/find_house_manager/?${params}`);
      setProfiles(response.data)
    } catch (error) {
      console.log('Error in fetching house manager', error)
    } finally {
      setIsLoading(false)
    }
  };


  return (
    <div className={styles.findHouseGirlContainer}>
      <div className={styles.filterSection}>
        <h2>Find House Girl</h2>
        <div className={styles.filters}>
          <input
            type="text"
            name="location"
            placeholder="Enter Location"
            className={styles.filterInput}
            value={filters.location}
            onChange={handleFilterChange}
          />
          <select
            name="rating"
            className={styles.filterSelect}
            value={filters.rating}
            onChange={handleFilterChange}
          >
            <option value="">Select Rating</option>
            <option value="5">5 Stars</option>
            <option value="4">4 Stars & Up</option>
            <option value="3">3 Stars & Up</option>
          </select>
          <input
            type="text"
            name="experience"
            placeholder="Years of Experience"
            className={styles.filterInput}
            value={filters.experience}
            onChange={handleFilterChange}
          />
          <button className={styles.filterButton} onClick={handleSearch}>
            Apply Filters
          </button>
        </div>
      </div>

      <div className={styles.profilesGrid}>
        {isLoading ? (
          <p className={styles.loadingContent}>
                  <FontAwesomeIcon icon={faSpinner} spin size="3x" className={styles.spinner} />
                  <span className={styles.loadingText}>Loading...</span>
          </p>
        ) : profiles.length === 0 ? (
          <p>No House Manager has been found</p>
        ) : (
          profiles.map((profile) => (
            <div className={styles.profileCard} key={profile.id}>
              <img
                src={`${baseURL}${profile.image}`}
                alt={profile.first_name}
                className={styles.profileImage}
              />
              <div className={styles.profileDetails}>
                <h3>{profile.first_name} {profile.last_name}</h3>
                <p>
                  <FontAwesomeIcon icon={faMapMarkerAlt} style={{color: '#007bff'}}/> {profile.location}
                </p>
                <p>
                  <FontAwesomeIcon icon={faStar} style={{color: '#f39c12'}}/> {profile.rating.toFixed(1)} Stars
                </p>
                <p>{profile.experience} years Experience</p>
                <p>Available: {profile.availability}</p>
                <button className={styles.contactButton}>
                  <Link
                      to={`/profile/house_manager/${profile.id}`}
                      key={profile.id}
                  >
                    View Profile
                  </Link>
                </button>
                
              </div>
            </div>
          ))
        )}
        
      </div>
    </div>
  );
};

export default FindHouseGirl;
